import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { getParagraphContainerSx, paragraphBlockToHtml } from "../../../../utils/articleParagraphUtils";
import { toRem } from "./articleMagazinePreviewTokens";
import { articleBodyParagraphSx, magazineArticleBodyContentSx } from "./articleMagazinePreviewStyles";

const ArticleContentPreviewRenderer = ({ content }) => {
  if (!content?.blocks?.length) {
    return null;
  }

  return (
    <Box sx={magazineArticleBodyContentSx}>
      {content.blocks.map((block, index) => {
        if (block.type === "paragraph") {
          return (
            <Box
              key={`paragraph-${index}`}
              sx={getParagraphContainerSx(block, articleBodyParagraphSx)}
              dangerouslySetInnerHTML={{ __html: paragraphBlockToHtml(block) }}
            />
          );
        }
        if (block.type === "image" && block.publicUrl) {
          return (
            <Box
              key={`image-${index}`}
              component="img"
              src={block.publicUrl}
              alt={block.alt || ""}
              sx={{
                width: "100%",
                maxWidth: "100%",
                borderRadius: toRem(20),
                display: "block",
              }}
            />
          );
        }
        return null;
      })}
    </Box>
  );
};

ArticleContentPreviewRenderer.propTypes = {
  content: PropTypes.shape({
    version: PropTypes.number,
    blocks: PropTypes.arrayOf(PropTypes.object),
  }),
};

export default ArticleContentPreviewRenderer;
